import React from 'react';

import { SelectTextField } from '@lumapps/combobox/components/SelectTextField';
import { useDataAttributes } from '@lumapps/data-attributes';
import { useGroupInfoContent } from '@lumapps/groups/hooks/useGroupInfoContent';
import { Group } from '@lumapps/groups/types';

export interface GroupMoreInfoProps {
    /** The group object for which to display more information. */
    group: Group;
    /** Scope for tracking purposes. */
    scope: string;
}

/**
 * GroupMoreInfo component displays additional information about a group.
 * It uses a popover to show group-specific content when triggered.
 *
 * @param {GroupMoreInfoProps}
 * @returns GroupMoreInfo
 */
export const GroupMoreInfo: React.FC<GroupMoreInfoProps> = ({ group, scope }) => {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState<boolean>(false);
    const { get } = useDataAttributes(scope);

    const { GroupUserSizePopoverContent } = useGroupInfoContent({
        group,
        isOpen: isPopoverOpen,
        setIsOpen: setIsPopoverOpen,
    });

    return (
        <SelectTextField.OptionMoreInfo
            onToggle={setIsPopoverOpen}
            buttonProps={get({ element: 'info', action: group.uid })}
        >
            {GroupUserSizePopoverContent}
        </SelectTextField.OptionMoreInfo>
    );
};
